export default {
	links: [
		{
			name: 'За дома',

			dropdownItems: [
				{
					name: 'Срочни',
					href: '/za-doma/',
					external: false
				},
				{
					name: 'Безсрочни',
					href: '/za-doma-bezsrochni',
					external: false
				}
			]
		},
		{
			name: 'За бизнеса',
			href: '/za-biznesa/',
			external: false
		},
		{
			name: 'Промоции',
			showPromoIcon: true,
			href: '/promocii/',
			external: false
		},
		{
			name: 'Aurora TV',
			href: '/aurora-tv/',
			external: false
		},
		{
			name: 'Netsurf Play',
			showPlayIcon: true,
			href: '/netsurf-play/',
			external: false
		},
		{
			name: 'Полезно',
			dropdownItems: [
				{
					name: 'Какво е GPON',
					href: '/kakvo-e-gpon/',
					external: false
				},
				{
					name: 'Защо NetSurf',
					href: '/zashto-netsurf/',
					external: false
				},
				{
					name: 'Помощ',
					href: '/help-center/',
					external: false
				},
				{
					name: 'Блог',
					href: undefined,
					externalHref: 'https://blog.netsurf.bg/',
					external: true
				}
			]
		}
	]
};

